<template>
    <div>
        <div v-if="canShowContent">
            <Content :content="content" model="section" :api-key="apiKey" :data="categoryData" />
        </div>
    </div>
</template>
<script>
const apiKey = import.meta.env.VITE_APP_BUILDER_API_KEY
import { Content, fetchOneEntry, isPreviewing } from '@builder.io/sdk-vue'

export default {
    name: 'FooterBlockContent',
    components: {
        Content,
    },
    data: () => ({
        apiKey,
        content: null,
    }),
    computed: {
        canShowContent() {
            return !!this.content || isPreviewing()
        },
    },
    mounted() {
        fetchOneEntry({
            model: 'footer-wrapper',
            apiKey,
        }).then((content) => {
            this.content = content
        })
    },
}
</script>
<style lang="scss"></style>
